import React from 'react';
import Socios from '../Socios/Socios';

const PontoDeApoio = () => {
  return <Socios showOnlyPontoDeApoio />;
};

export default PontoDeApoio;
